/* EvaMats PL — configurator step events.
   Publishes to Shopify.analytics (app pixel) and dataLayer.
   Does not load gtag and does not emit add_to_cart. */
(function () {
  if (window.__evmCfgAnalytics) return;
  window.__evmCfgAnalytics = true;

  var STEPS = [
    { key: 'year', number: 1, name: 'year' },
    { key: 'mats_set_type', number: 2, name: 'mat_type_variant' },
    { key: 'mat_patterns_colors', number: 3, name: 'shape_colors' },
    { key: 'heel', number: 4, name: 'heel_pad' },
    { key: 'extras', number: 5, name: 'additional_options' }
  ];

  function findRoot() {
    var products = document.querySelectorAll('.product');
    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      if (
        product.querySelector('[data-dropdown="year"]') &&
        product.querySelector('[data-dropdown="mats_set_type"]') &&
        product.querySelector('[data-dropdown="mat_patterns_colors"]')
      ) {
        return product;
      }
    }
    return null;
  }

  var root = findRoot();
  if (!root) return;

  var passId = null;
  var started = false;
  var openKey = null;
  var summaryOn = false;
  var cartSentFor = null;
  var addArmedAt = 0;
  var continueSnap = null;
  var continueTimer = 0;
  var completeLock = '';

  function ensureId() {
    if (!passId) passId = 'cfg_' + Date.now();
    return passId;
  }

  function rotatePass() {
    passId = null;
    started = false;
    openKey = null;
    summaryOn = false;
    cartSentFor = null;
    completeLock = '';
  }

  function clean(payload) {
    Object.keys(payload).forEach(function (key) {
      if (payload[key] == null || payload[key] === '') delete payload[key];
    });
    return payload;
  }

  function publish(eventName, payload) {
    var data = clean(payload);
    window.dataLayer = window.dataLayer || [];
    var layer = { event: eventName };
    Object.keys(data).forEach(function (key) {
      layer[key] = data[key];
    });
    window.dataLayer.push(layer);
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(eventName, data);
    }
  }

  function money(text) {
    var match = String(text || '').replace(/\s+/g, '').match(/(\d+(?:[.,]\d+)?)/);
    if (!match) return null;
    var value = Math.round(parseFloat(match[1].replace(',', '.')));
    return isNaN(value) ? null : value;
  }

  function currentPrice() {
    var now = root.querySelector('.evm-main-now');
    var fromNow = now && money(now.textContent);
    if (fromNow != null) return fromNow;
    var sticky = document.querySelector('.sticky_config_price_price');
    return sticky ? money(sticky.textContent) : null;
  }

  function variantId() {
    var input = root.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"]');
    return input && input.value ? String(input.value) : undefined;
  }

  function productId() {
    return root.getAttribute('data-product-id') || undefined;
  }

  function productTitle() {
    var heading = root.querySelector('.h1, h1');
    return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function common() {
    return {
      configuration_id: ensureId(),
      product_id: productId(),
      variant_id: variantId(),
      current_price: currentPrice(),
      currency: 'PLN'
    };
  }

  function stepOf(wrapper) {
    if (!wrapper) return null;
    var dropdown = wrapper.getAttribute('data-dropdown');
    var key = dropdown;
    if (!key && wrapper.classList.contains('product__dropdown_wr--heel')) key = 'heel';
    if (!key && wrapper.classList.contains('product__dropdown_wr--extras')) key = 'extras';
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].key === key) return { el: wrapper, number: STEPS[i].number, name: STEPS[i].name, key: key };
    }
    return null;
  }

  function openStep() {
    var wrappers = root.querySelectorAll('.product__dropdown_wr.open');
    for (var i = 0; i < wrappers.length; i++) {
      var step = stepOf(wrappers[i]);
      if (step) return step;
    }
    return null;
  }

  function checkedTitle(selector) {
    var input = root.querySelector(selector);
    if (!input) return '';
    return (input.getAttribute('data-title') || input.value || '').trim();
  }

  function itemTitle(input) {
    if (!input) return '';
    if (input.getAttribute('data-title')) return input.getAttribute('data-title').trim();
    var box = input.closest('.product__upsell_item, .product__extras_item');
    var title = box && box.querySelector('.product__upsell_item_title');
    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function mountValue(input) {
    var box = input && input.closest('.product__upsell_item');
    var active = box && box.querySelector('.montaz-option.active');
    if (!active) return '';
    return (active.getAttribute('data-value') || active.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function choiceFields(step) {
    var fields = { step_skipped: false };
    if (!step) return fields;
    if (step.name === 'year') {
      var yearEl = root.querySelector('#rok-produkcji');
      var year = yearEl && parseInt(yearEl.value, 10);
      if (year) fields.vehicle_year = year;
      fields.vehicle_model = productTitle();
    }
    if (step.name === 'mat_type_variant') {
      fields.mat_type = checkedTitle('fieldset[data-name="mats_type"] input[type="radio"]:checked');
      fields.mat_variant = checkedTitle('fieldset[data-name="mats_set"] input[type="radio"]:checked');
    }
    if (step.name === 'shape_colors') {
      fields.cell_shape = checkedTitle('fieldset[data-type="matPattern"] input[type="radio"]:checked');
      fields.material_color = checkedTitle('fieldset[data-type="matColor"] input[type="radio"]:checked');
      fields.trim_color = checkedTitle('fieldset[data-type="trimColor"] input[type="radio"]:checked');
    }
    if (step.name === 'heel_pad') {
      var heel = root.querySelector('input[name="product__upsell"]:checked');
      if (!heel) {
        fields.heel_pad_type = 'none';
        fields.step_skipped = true;
      } else {
        fields.heel_pad_type = itemTitle(heel);
        fields.heel_pad_mounting = mountValue(heel);
      }
    }
    if (step.name === 'additional_options') {
      var extras = [];
      root.querySelectorAll('input[name="product__extras"]:checked').forEach(function (input) {
        var title = itemTitle(input);
        if (title) extras.push(title);
      });
      fields.additional_options = extras;
      fields.step_skipped = extras.length === 0;
    }
    return fields;
  }

  function summaryFields() {
    var fields = common();
    ['year', 'mat_type_variant', 'shape_colors', 'heel_pad', 'additional_options'].forEach(function (name) {
      var choices = choiceFields({ name: name });
      Object.keys(choices).forEach(function (key) {
        if (key === 'step_skipped') return;
        if (choices[key] != null && choices[key] !== '') fields[key] = choices[key];
      });
    });
    return fields;
  }

  function isSummaryVisible() {
    var summary = root.querySelector('.evm-summary');
    return !!(summary && summary.classList.contains('is-on') && !summary.hasAttribute('hidden'));
  }

  function missingField(wrapper) {
    var elements = wrapper.querySelectorAll('input[required], select[required], textarea[required]');
    var seen = {};
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (element.type === 'radio') {
        if (seen[element.name]) continue;
        seen[element.name] = true;
        var checked = wrapper.querySelector('input[type="radio"][name="' + element.name.replace(/"/g, '\\"') + '"]:checked');
        if (!checked) {
          if (element.id === 'rok-produkcji' || /rok produkcji/i.test(element.name || '')) return 'vehicle_year';
          return element.name || element.id || 'required';
        }
      } else if (element.type === 'checkbox') {
        if (!element.checked) return element.name || element.id || 'required';
      } else if (!String(element.value || '').trim()) {
        if (element.id === 'rok-produkcji' || /rok produkcji/i.test(element.name || '')) return 'vehicle_year';
        return element.name || element.id || 'required';
      }
    }
    return 'required';
  }

  function onStepOpened(step) {
    if (!step || openKey === step.name) return;
    openKey = step.name;
    var payload = common();
    payload.step_number = step.number;
    payload.step_name = step.name;
    publish('configurator_step_view', payload);
  }

  function watchSteps() {
    root.querySelectorAll('.product__dropdown_wr').forEach(function (wrapper) {
      var step = stepOf(wrapper);
      if (!step) return;
      var wasOpen = wrapper.classList.contains('open');
      if (wasOpen) onStepOpened(step);
      new MutationObserver(function () {
        var isOpen = wrapper.classList.contains('open');
        if (isOpen && !wasOpen) onStepOpened(stepOf(wrapper));
        wasOpen = isOpen;
      }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function watchSummary() {
    var summary = root.querySelector('.evm-summary');
    if (!summary) return;
    function sync() {
      var visible = isSummaryVisible();
      if (visible && !summaryOn) {
        summaryOn = true;
        openKey = 'summary';
        publish('configurator_summary_view', summaryFields());
      } else if (!visible) {
        summaryOn = false;
      }
    }
    var summaryTimer = 0;
    function schedule() {
      var visible = isSummaryVisible();
      if (!visible) {
        summaryOn = false;
        clearTimeout(summaryTimer);
        return;
      }
      if (summaryOn) return;
      clearTimeout(summaryTimer);
      summaryTimer = setTimeout(sync, 220);
    }
    new MutationObserver(schedule).observe(summary, { attributes: true, attributeFilter: ['class', 'hidden'] });
  }

  function armContinue(cta, from) {
    if (!from) return;
    continueSnap = { cta: cta, from: from };
    clearTimeout(continueTimer);
    continueTimer = setTimeout(settleContinue, 180);
  }

  function settleContinue() {
    var snap = continueSnap;
    continueSnap = null;
    if (!snap || !snap.from || !snap.from.el) return;
    var from = snap.from;
    var wrapper = from.el;
    var completed = wrapper.classList.contains('complete') || wrapper.classList.contains('evm-passed');
    var next = openStep();
    var moved = (next && next.name !== from.name) || isSummaryVisible();
    if (!completed || !moved) {
      if (!completed) {
        var errorPayload = common();
        errorPayload.step_number = from.number;
        errorPayload.step_name = from.name;
        errorPayload.field_name = missingField(wrapper);
        errorPayload.error_type = 'required_field_missing';
        errorPayload.cta_source = snap.cta;
        publish('configurator_validation_error', errorPayload);
      }
      return;
    }

    var destination = next && next.name !== from.name ? next.name : 'summary';
    var lock = from.name + '>' + destination;
    if (completeLock === lock) return;
    completeLock = lock;
    setTimeout(function () {
      if (completeLock === lock) completeLock = '';
    }, 400);

    if (!started && from.name === 'year') {
      var yearEl = root.querySelector('#rok-produkcji');
      if (yearEl && yearEl.value) {
        started = true;
        publish('configurator_start', common());
      }
    }

    var payload = common();
    var choices = choiceFields(from);
    Object.keys(choices).forEach(function (key) {
      payload[key] = choices[key];
    });
    payload.step_number = from.number;
    payload.step_name = from.name;
    payload.cta_source = snap.cta;
    publish('configurator_step_complete', payload);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var sticky = target.closest('.sticky_add_to_cart');
    var dalej = target.closest('.product__dropdown_button');
    var nextBtn = target.closest('.evm-next');
    var inRoot = !!(dalej && root.contains(dalej)) || !!(nextBtn && root.contains(nextBtn));

    if (sticky && isSummaryVisible()) {
      addArmedAt = Date.now();
      return;
    }
    if (target.closest('.product-form__submit, .evm-sum-atc') && root.contains(target)) {
      addArmedAt = Date.now();
    }

    if (sticky && !isSummaryVisible()) {
      armContinue('sticky', openStep());
      return;
    }
    if (!inRoot) return;
    var cta = 'inline';
    if (!event.isTrusted || (continueSnap && continueSnap.cta === 'sticky')) cta = 'sticky';
    armContinue(cta, openStep() || (continueSnap && continueSnap.from));
  }, true);

  root.addEventListener('change', function (event) {
    if (!event.isTrusted || started) return;
    if (!event.target.closest || !event.target.closest('[data-dropdown="year"]')) return;
    var yearEl = root.querySelector('#rok-produkcji');
    if (!yearEl || !yearEl.value) return;
    started = true;
    publish('configurator_start', common());
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.evm-pv-expand');
    if (!button || !root.contains(button)) return;
    setTimeout(function () {
      var step = openStep();
      var payload = {
        configuration_id: ensureId(),
        step_name: step ? step.name : (isSummaryVisible() ? 'summary' : undefined),
        preview_state: button.getAttribute('aria-expanded') === 'true' ? 'expanded' : 'collapsed'
      };
      if (step) payload.step_number = step.number;
      publish('configurator_preview_toggle', payload);
    }, 0);
  });

  function emitCartParams() {
    var id = passId;
    if (!id || !started || cartSentFor === id) return;
    if (Date.now() - addArmedAt > 8000) return;
    cartSentFor = id;
    var payload = summaryFields();
    payload.configuration_id = id;
    publish('configurator_cart_params', payload);
    rotatePass();
  }

  if (!window.__evmCfgAnalyticsFetch && typeof window.fetch === 'function') {
    window.__evmCfgAnalyticsFetch = true;
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var pending = originalFetch.apply(this, arguments);
      if (String(url).indexOf('/cart/add') === -1) return pending;
      return pending.then(function (response) {
        if (response && response.ok) emitCartParams();
        return response;
      });
    };
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      emitCartParams();
    });
  }

  watchSteps();
  watchSummary();
})();
